export const GUIDED_WORKFLOW_COMMAND = Object.freeze({
  SKIP: "skip",
  CANCEL: "cancel",
  BACK: "back",
  YES: "yes",
  NO: "no",
});

const SKIP_PHRASES = new Set(["skip", "next"]);
const CANCEL_PHRASES = new Set(["cancel", "stop"]);
const BACK_PHRASES = new Set(["back"]);
const YES_PHRASES = new Set(["yes", "yeah", "yep", "correct"]);
const NO_PHRASES = new Set(["no", "nope", "wrong"]);

function normalizeTranscript(transcript) {
  return String(transcript || "").toLowerCase().trim();
}

export function classifyWorkflowCommand(transcript) {
  const normalized = normalizeTranscript(transcript);
  if (!normalized) {
    return null;
  }

  if (SKIP_PHRASES.has(normalized)) {
    return GUIDED_WORKFLOW_COMMAND.SKIP;
  }

  if (CANCEL_PHRASES.has(normalized)) {
    return GUIDED_WORKFLOW_COMMAND.CANCEL;
  }

  if (BACK_PHRASES.has(normalized)) {
    return GUIDED_WORKFLOW_COMMAND.BACK;
  }

  if (YES_PHRASES.has(normalized)) {
    return GUIDED_WORKFLOW_COMMAND.YES;
  }

  if (NO_PHRASES.has(normalized)) {
    return GUIDED_WORKFLOW_COMMAND.NO;
  }

  return null;
}

export function isReservedWorkflowCommand(transcript) {
  return classifyWorkflowCommand(transcript) !== null;
}

export function isGuidedSkipCommand(transcript) {
  return classifyWorkflowCommand(transcript) === GUIDED_WORKFLOW_COMMAND.SKIP;
}

export function isGuidedCancelCommand(transcript) {
  return classifyWorkflowCommand(transcript) === GUIDED_WORKFLOW_COMMAND.CANCEL;
}
